/**
 * Bundle wrapping Chosen plus its Image-Select extension (and both style sheets).
 * Update 8/5/2020 -- monkey match to prevent propagation on key events in search field.
 */


var $ = require('jquery'); // ( provide plugin already exports jQuery to the chosen module)

require('./chosen.less');
require('./chosen-image-select.less');

// Note this module doesn't anything -- it exports chosen to global $.fn --> $.fn.chosen
require('chosen-js');


/**
 *  DVBC-1328 - monkey patch solution to stop propagation of key events to avoid problems
 *  associated with forking library and implementing hotkey solution.
 *  Stop keydown propagation in search_field.
 *  Note: confirmed event will be taken off the node.
 *  console.log($._data(c.search_field[0],'events'));
 *  Could make this an option if we need to allow.
 *  Update: now also prevents forms submission if the enter key is pressed in case the widget's inside a form.
 */


var fn_original_chosen = $.fn.chosen;

$.fn.extend({

   chosen: function( options ) {

       // May not be necessary but ensure turn we off our key event handler,
       // before its destroyed by chosen.
       if (options === 'destroy') {

           this.each( function() {

               var chosen = $(this).data('chosen');

               // Ensure there is a chosen to prevent run time errors --
               // Encountered issing calling viewer.destroy which this removed the layout subapp first,
               // this to be undefined.
               // Should research that further -- potential for memory leaks (see DVBC-1790)
               if ( chosen ) {
                   chosen.search_field.off();
                   // Maybe put $(this).off here ... ?
               }

           });

       }

       fn_original_chosen.apply( this, arguments );

       // Don't reapply if destroyed.
       if ( options === 'destroy' ) {
            return;
       }

       // Apply the patch
       this.each( function() {

            var chosen = $(this).data('chosen');
            chosen.search_field
                .off('keydown.chosen') //don't need keyup as well, this should do
                .on('keydown.chosen', function(e) {

                    e.stopPropagation();

                    if ( e.keyCode === 13 ) {
                        e.preventDefault();
                    }

                    return chosen.keydown_checker(e);

                });

       });

       return $(this);
   }

});


// Now bundle the extension library
require('@feith/image-select');



// Don't really need the export is this project, but export something anyway
module.exports = $.fn.chosen;


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/plugin/vendor/bundle/chosen/chosen-bundle.js
 ** module id = 163
 ** module chunks = 0
 **/